import { Routes, Route } from "react-router-dom";
import { ParallelPersonaProvider } from "../context/ParallelPersonaContext";
import ParallelUploadPage from "../pages/parallel/ParallelUploadPage";
import ParallelRegionPage from "../pages/parallel/ParallelRegionPage";
import ParallelEthnicityPage from "../pages/parallel/ParallelEthnicityPage";
import ParallelTopicPage from "../pages/parallel/ParallelTopicPage";
import ParallelConfirmationPage from "../pages/parallel/ParallelConfirmationPage";
import ParallelPersonasPage from "../pages/parallel/ParallelPersonasPage";
import ParallelLoadingPage from "../pages/parallel/ParallelLoadingPage";
import ErrorPage from "../pages/ErrorPage";

const ParallelFlowRouter = () => (
  <ParallelPersonaProvider>
    <Routes>
      <Route path="upload" element={<ParallelUploadPage />} />
      <Route path="region" element={<ParallelRegionPage />} />
      <Route path="ethnicity" element={<ParallelEthnicityPage />} />
      <Route path="topics" element={<ParallelTopicPage />} />
      <Route path="confirm" element={<ParallelConfirmationPage />} />
      <Route path="personas" element={<ParallelPersonasPage />} />
      <Route path="loading" element={<ParallelLoadingPage />} />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  </ParallelPersonaProvider>
);

export default ParallelFlowRouter;
